var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26.67 26.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.11,
    y1: 13.74,
    x2: 15.36,
    y2: 11.98,
    gradientTransform: "translate(0 28.67) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6363d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8989ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#998dec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d89d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1a382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.79,
    y1: 31.27,
    x2: 19.57,
    y2: 0.16,
    gradientTransform: "translate(0 28.67) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6363d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8989ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#998dec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d89d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1a382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11.29,
    y1: 18.72,
    x2: 12.54,
    y2: 16.97,
    gradientTransform: "translate(0 28.67) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6363d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8989ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#998dec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d89d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1a382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.33,16.69h.31c.44,0,.81-.4,.81-.89,0-.63-.15-.71-.57-.85l-.55-.19v1.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.33,0C5.97,0,0,5.97,0,13.33s5.97,13.33,13.33,13.33,13.33-5.97,13.33-13.33S20.69,0,13.33,0ZM7.44,19.23c.39,.39,.39,1.03,0,1.41-.2,.2-.45,.29-.71,.29s-.51-.09-.71-.29c-1.95-1.95-3.03-4.55-3.03-7.31s1.08-5.36,3.03-7.31c.39-.39,1.03-.39,1.41,0,.39,.39,.39,1.03,0,1.41-1.57,1.57-2.44,3.67-2.44,5.89s.87,4.32,2.44,5.89Zm8.09-6.19c1.28,.45,1.91,1.35,1.91,2.75,0,1.6-1.25,2.89-2.81,2.89h-.31v.24c0,.55-.45,1-1,1s-1-.45-1-1v-.24h-.04c-1.69,0-3.08-1.43-3.08-3.17,0-.55,.45-1,1-1s1,.45,1,1c0,.65,.48,1.17,1.08,1.17h.04v-2.64l-1.2-.43c-1.28-.45-1.91-1.35-1.91-2.75,0-1.6,1.25-2.89,2.81-2.89h.31v-.24c0-.55,.45-1,1-1s1,.45,1,1v.24h.04c1.69,0,3.08,1.43,3.08,3.17,0,.55-.45,1-1,1s-1-.45-1-1c0-.65-.48-1.17-1.08-1.17h-.04v2.64l1.2,.43Zm5.11,7.6c-.2,.2-.45,.29-.71,.29s-.51-.09-.71-.29c-.39-.39-.39-1.03,0-1.41,1.57-1.57,2.44-3.67,2.44-5.89s-.87-4.32-2.44-5.89c-.39-.39-.39-1.03,0-1.41s1.03-.39,1.41,0c1.95,1.95,3.03,4.55,3.03,7.31s-1.08,5.36-3.03,7.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.23,10.88c0,.63,.15,.71,.57,.85l.55,.19v-1.95h-.31c-.45,0-.81,.41-.81,.91Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.923e239464fa25bdf61f7d12da791053.svg";
export { ForwardRef as ReactComponent };